import { IAuthorityHistoryModel } from './authority-history.interface';
import { ChangeHighlight, IChangeHighlight } from './changehighlight';
import { ChangeRequest } from './changerequest';
import { Comment, IComment } from './comment';
import { CrossOver, ICrossOver } from './crossover';
import { DisplayStatus } from './displaystatus.enum';
import { EnabledFeatures, IEnabledFeatures } from './enabledfeatures';
import { ILineItem, LineItem } from './lineitem';
import { ILocation, Location } from './location';
import { Source } from './source.enum';
import { Status } from './status.enum';
import { IUser, User } from './user';
import { IUserConfirmation } from './userconfirmation';
import { AppConstant } from '../common/app.constant';
import { MenuItem } from 'primeng/api';
import { EmployeeInCharge, IEmployeeInCharge } from './employeeInCharge';
import { EICChangeRequestModal } from './eic-change-request-model';
import { EICSTatus } from './eic-status.enum';
import { Subdivision } from './subdivision';
import { Track } from './track';
import { ChangeRequestType } from './change-request-type.enum';

export class TrackAuthority {
  id: number;
  ec1Number: number;
  entryLocation: Location;
  displayStatus: DisplayStatus;
  status: Status;
  effective: Date;
  cancelled: Date;
  released: Date;
  expiration: Date;
  employeeInCharges: Array<EmployeeInCharge>;
  lineItems: Array<LineItem>;
  comments: Array<Comment>;
  crossOvers: Array<CrossOver>;
  userConfirmationList: Array<IUserConfirmation>;
  dispatcher: string;
  lastUpdatedDate: Date;
  createDate: Date;
  authorityChanges: Array<ChangeHighlight>;
  sourceSystemName: Source;
  denialReasonCode: string;
  authorityChangeRequests: Array<ChangeRequest>;
  modifyReportbyChangeRequest: ChangeRequest;
  enabledFeatures: EnabledFeatures;
  dirty?: boolean;
  shared?: String;
  trackAuthorityHistoryModels: Array<IAuthorityHistoryModel>;
  transferFailed?: boolean;
  transferSuccess?: boolean;
  authorityMenu: MenuItem[] = AppConstant.ELIPSIS_MENU_ARRAY;
  isAuthorityShared?: boolean;
  isLoggedUserPrimary?: boolean = false;
  primaryUserDetail?: EmployeeInCharge;
  isSharedModificationRejected?: boolean;
  notificationId: number;
  isDisabled?: boolean;
  activeSecondoriesCount: number;
  eicChangeRequests: EICChangeRequestModal[] = new Array<EICChangeRequestModal>();
  loggedInEICDetail: EmployeeInCharge;
  primaryDetail: EmployeeInCharge;
  range: number;
  rejectedChangeRequestId?: number;
  static deepCopy(source: any, destination: any): void {
    for (let key in source) {
      if (source[key] instanceof Array) {
        destination[key] = source[key];
      } else if (key === 'deepCopy' || !(key in destination)) {
        continue;
      } else if (source[key] !== Object(source[key]) || source[key] instanceof String || source[key] instanceof Date) {
        destination[key] = source[key];
      } else {
        this.deepCopy(source[key], destination[key]);
      }
    }
  }

  constructor(private trackAuthority: ITrackAuthority, private currentUserRACF: string) {
    this.isAuthorityShared = false;
    this.activeSecondoriesCount = 0;
    this.id = trackAuthority.id;
    this.ec1Number = trackAuthority.ec1Number;
    this.displayStatus = DisplayStatus[trackAuthority.displayStatus];
    this.status = Status[trackAuthority.status];
    this.effective = trackAuthority.effective && new Date(trackAuthority.effective.toString().slice(0, -5));
    this.cancelled = trackAuthority.cancelled && new Date(trackAuthority.cancelled.toString().slice(0, -5));
    this.released = trackAuthority.released && new Date(trackAuthority.released.toString().slice(0, -5));
    this.expiration = new Date(trackAuthority.expiration.toString().slice(0, -5));
    this.range = trackAuthority.range;
    this.modifyReportbyChangeRequest = new ChangeRequest();
    this.authorityChangeRequests = new Array<ChangeRequest>();
    if (trackAuthority.authorityChangeRequests) {
      for (const element of trackAuthority.authorityChangeRequests) {
        let changeRequest = new ChangeRequest(element);
        this.authorityChangeRequests.push(changeRequest);
        if (changeRequest.type !== ChangeRequestType.SHARE && changeRequest.type !== ChangeRequestType.UNSHARE) {
          this.modifyReportbyChangeRequest = changeRequest;
        }
      }
    }
    this.employeeInCharges = new Array<EmployeeInCharge>();
    if (trackAuthority.employeeInCharges) {
      const eicComment = {};
      trackAuthority.comments.forEach(comment => {
        if (!eicComment[comment.racf]) {
          eicComment[comment.racf] = { comment: comment.text, authorityChangeRequestId: comment.authorityChangeRequestId };
        }
      });
      for (let i = 0; i < trackAuthority.employeeInCharges.length; i++) {
        trackAuthority.employeeInCharges[i].selected = 0;
        if (trackAuthority.employeeInCharges[i].eicUserId === currentUserRACF) {
          this.loggedInEICDetail = new EmployeeInCharge(trackAuthority.employeeInCharges[i]);
          this.isLoggedUserPrimary = this.loggedInEICDetail.primary;
          if (
            this.modifyReportbyChangeRequest.authorityChangeRequestId ||
            (this.loggedInEICDetail.status !== EICSTatus.RELEASED &&
              this.loggedInEICDetail.status !== EICSTatus.REJECTED &&
              this.loggedInEICDetail.status !== EICSTatus.CANCELLED)
          ) {
            this.isDisabled = true;
          }
        }
        if (!trackAuthority.employeeInCharges[i].primary) {
          if (
            trackAuthority.employeeInCharges[i].status !== EICSTatus.RELEASED &&
            trackAuthority.employeeInCharges[i].status !== EICSTatus.REJECTED &&
            trackAuthority.employeeInCharges[i].status !== EICSTatus.CANCELLED
          ) {
            this.isAuthorityShared = true;
          }

          if (trackAuthority.employeeInCharges[i].status === EICSTatus.ACTIVE) {
            this.activeSecondoriesCount++;
          }
        } else if (trackAuthority.employeeInCharges[i].primary) {
          this.primaryDetail = new EmployeeInCharge(trackAuthority.employeeInCharges[i]);
          let entryLocation = {} as ILocation;
          entryLocation.milepost = trackAuthority.employeeInCharges[i].entryMilepostId;
          entryLocation.prefix = trackAuthority.employeeInCharges[i].entryMilepostPrefix;
          entryLocation.subdivision = trackAuthority.subdivision;
          entryLocation.track = trackAuthority.track;
          entryLocation.range = trackAuthority.range;
          this.entryLocation = new Location(entryLocation);
          this.primaryUserDetail = new EmployeeInCharge(trackAuthority.employeeInCharges[i]);
        }

        trackAuthority.employeeInCharges[i].rejectReason = '';
        this.employeeInCharges.push(new EmployeeInCharge(trackAuthority.employeeInCharges[i]));
        this.authorityChangeRequests.map((acr: ChangeRequest) => {
          let eicChangeRequest: EICChangeRequestModal = new EICChangeRequestModal();
          if (acr.sharingChangeModel && acr.sharingChangeModel.secondaryEICRacf === trackAuthority.employeeInCharges[i].eicUserId) {
            eicChangeRequest.authorityChangeRequestId = acr.authorityChangeRequestId;
            eicChangeRequest.authorityChangeRequestStatus = acr.authorityChangeRequestStatus;
            eicChangeRequest.status = trackAuthority.employeeInCharges[i].status;
            this.eicChangeRequests[trackAuthority.employeeInCharges[i].eicUserId] = eicChangeRequest;
          }
        });
        this.employeeInCharges[i].comment =
          eicComment[trackAuthority.employeeInCharges[i].eicUserId] &&
          this.eicChangeRequests[trackAuthority.employeeInCharges[i].eicUserId] &&
          eicComment[trackAuthority.employeeInCharges[i].eicUserId].authorityChangeRequestId ===
            this.eicChangeRequests[trackAuthority.employeeInCharges[i].eicUserId].authorityChangeRequestId
            ? eicComment[trackAuthority.employeeInCharges[i].eicUserId].comment
            : '';
      }
    }
    this.lastUpdatedDate =
      trackAuthority.lastUpdatedDate === undefined ? undefined : new Date(trackAuthority.lastUpdatedDate.toString().slice(0, -5));
    this.createDate = trackAuthority.createDate === undefined ? undefined : new Date(trackAuthority.createDate.toString().slice(0, -5));
    this.sourceSystemName = trackAuthority.sourceSystemName;
    this.denialReasonCode = trackAuthority.denialReasonCode;

    this.enabledFeatures = trackAuthority.enabledFeatures === undefined ? new EnabledFeatures(undefined) : trackAuthority.enabledFeatures;

    this.lineItems = new Array<LineItem>();
    for (let i = 0; i < trackAuthority.lineItems.length; i++) {
      this.lineItems.push(new LineItem(trackAuthority.lineItems[i]));
    }

    this.comments = new Array<Comment>();
    if (trackAuthority.comments !== undefined) {
      for (let i = 0; i < trackAuthority.comments.length; i++) {
        this.comments.push(new Comment(trackAuthority.comments[i]));
      }
    }

    this.crossOvers = new Array<CrossOver>();
    if (trackAuthority.crossOvers !== undefined) {
      for (let i = 0; i < trackAuthority.crossOvers.length; i++) {
        this.crossOvers.push(new CrossOver(trackAuthority.crossOvers[i]));
      }
    }

    this.dispatcher = trackAuthority.dispatcher;

    this.authorityChanges = new Array<ChangeHighlight>();
    if (trackAuthority.authorityChanges !== undefined) {
      for (let i = 0; i < trackAuthority.authorityChanges.length; i++) {
        this.authorityChanges.push(new ChangeHighlight(trackAuthority.authorityChanges[i]));
      }
    }
    this.dirty = false;
    this.notificationId = trackAuthority.notificationId;
    this.isSharedModificationRejected = trackAuthority.isSharedModificationRejected;
    this.rejectedChangeRequestId = trackAuthority.rejectedChangeRequestId;
    this.trackAuthorityHistoryModels = trackAuthority.trackAuthorityHistoryModels;
    this.transferSuccess = trackAuthority.transferSuccess;
  }
}

export interface ITrackAuthority {
  id: number;
  ec1Number: number;
  entryLocation: ILocation;
  displayStatus: string;
  status: string;
  effective: number;
  cancelled: number;
  released: number;
  expiration: number;
  employeeInCharges: Array<IEmployeeInCharge>;
  lineItems: Array<ILineItem>;
  comments: Array<IComment>;
  crossOvers: Array<ICrossOver>;
  dispatcher: string;
  lastUpdatedDate: number;
  createDate: number;
  authorityChanges: Array<IChangeHighlight>;
  sourceSystemName: Source;
  denialReasonCode: string;
  authorityChangeRequests: Array<ChangeRequest>;
  enabledFeatures: IEnabledFeatures;
  trackAuthorityHistoryModels: Array<IAuthorityHistoryModel>;
  isSharedModificationRejected?: boolean;
  isDispatcherRejected?: boolean;
  notificationId: number;
  subdivision: Subdivision;
  rejectedChangeRequestId: number;
  track: Track;
  range: number;
  transferSuccess?: boolean;
}
